import { render, staticRenderFns } from "./MobileSearchedProducts.vue?vue&type=template&id=0a1211fe&scoped=true"
import script from "./MobileSearchedProducts.vue?vue&type=script&lang=js"
export * from "./MobileSearchedProducts.vue?vue&type=script&lang=js"
import style0 from "./MobileSearchedProducts.vue?vue&type=style&index=0&id=0a1211fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1211fe",
  null
  
)

export default component.exports